import {findAllIn, findIn, on} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-accreditation-form', function (form) {

        let showMoreInputs = findAllIn('.js-accreditation-form__show-more-input', form);
        showMoreInputs.map(function (input) {
            on('change', function(){
                let target = input.getAttribute('data-toggle-target');
                let targetElement = document.getElementById(target);
                targetElement.classList.toggle('checkbox__show-more--hidden');
            }, input);
        });

        let showTextarea = findAllIn('.js-accreditation-form__show-textarea', form);
        showTextarea.map(function (area) {
            let input = findIn('.js-accreditation-form__show-textarea__input', area);
            let textarea = findIn('.js-accreditation-form__show-textarea__textarea', area);

            on('change', function(){
                textarea.classList.toggle('checkbox__show-more--hidden');
            }, input);
        });
    });
}
